"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionCode = exports.QuestionSubmit = exports.QuestionFooter = exports.QuestionAnswer = exports.QuestionBody = exports.QuestionInput = exports.QuestionChoice = exports.QuestionChoices = exports.QuestionHeader = exports.Question = void 0;
var React = __importStar(require("react"));
var button_1 = __importDefault(require("@skillrecordings/react/dist/components/button"));
var context_1 = require("@reach/utils/context");
var auto_id_1 = require("@reach/auto-id");
var isArray_1 = __importDefault(require("lodash/isArray"));
var markdown_1 = __importDefault(require("../markdown"));
var sandpack_react_1 = require("@codesandbox/sandpack-react");
var sandpack_themes_1 = require("@codesandbox/sandpack-themes");
var QuestionContext = (0, context_1.createNamedContext)('QuestionContext', {});
var questionDefaultClasses = "";
var Question = React.forwardRef(function Question(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'form' : _b, _c = _a.horizontal, horizontal = _c === void 0 ? false : _c, className = _a.className, props = __rest(_a, ["children", "as", "horizontal", "className"]);
    className = "".concat(questionDefaultClasses, " ").concat(className ? className : '');
    var id = (0, auto_id_1.useId)(props.id);
    var context = __assign({ questionId: id }, props);
    return (React.createElement(QuestionContext.Provider, { value: context },
        React.createElement(Comp, { className: className, ref: forwardRef, onSubmit: context.onSubmit, "data-sr-quiz-question": "" }, children)));
});
exports.Question = Question;
var QuestionHeader = React.forwardRef(function QuestionHeader(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'legend' : _b, props = __rest(_a, ["children", "as"]);
    var _c = React.useContext(QuestionContext), currentQuestion = _c.currentQuestion, syntaxHighlighterTheme = _c.syntaxHighlighterTheme, config = _c.config;
    var questionBodyRenderer = config.questionBodyRenderer;
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-header": "" }),
        React.createElement(React.Fragment, null,
            children,
            questionBodyRenderer ? (questionBodyRenderer(currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.question)) : (React.createElement(markdown_1.default, { syntaxHighlighterTheme: syntaxHighlighterTheme }, currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.question)))));
});
exports.QuestionHeader = QuestionHeader;
var QuestionChoices = React.forwardRef(function QuestionChoices(_a, forwardRef) {
    var _b;
    var children = _a.children, _c = _a.as, Comp = _c === void 0 ? 'ul' : _c, _d = _a.grid, grid = _d === void 0 ? false : _d, props = __rest(_a, ["children", "as", "grid"]);
    var _e = React.useContext(QuestionContext), currentQuestion = _e.currentQuestion, errors = _e.formik.errors;
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-choices": "" }),
        children, (_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.choices) === null || _b === void 0 ? void 0 :
        _b.map(function (choice, i) {
            return React.createElement(QuestionChoice, { key: choice.answer, choice: choice, index: i });
        }),
        (errors === null || errors === void 0 ? void 0 : errors.answer) && (React.createElement("div", { "data-sr-quiz-question-error": "" }, errors === null || errors === void 0 ? void 0 : errors.answer))));
});
exports.QuestionChoices = QuestionChoices;
var QuestionChoice = React.forwardRef(function QuestionChoice(_a, forwardRef) {
    var children = _a.children, choice = _a.choice, index = _a.index, _b = _a.as, Comp = _b === void 0 ? 'li' : _b, props = __rest(_a, ["children", "choice", "index", "as"]);
    var _c = React.useContext(QuestionContext), isAnswered = _c.isAnswered, formik = _c.formik, hasMultipleCorrectAnswers = _c.hasMultipleCorrectAnswers, isCorrectChoice = _c.isCorrectChoice, hasCorrectAnswer = _c.hasCorrectAnswer, answer = _c.answer, currentAnswer = _c.currentAnswer;
    var alpha = Array.from(Array(26)).map(function (_, i) { return i + 65; });
    var alphabet = alpha.map(function (x) { return String.fromCharCode(x); });
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-choice": isAnswered && hasCorrectAnswer
            ? isCorrectChoice(choice)
                ? 'correct'
                : 'incorrect'
            : '' }),
        React.createElement("label", null,
            choice.image && React.createElement("img", { src: choice.image, alt: choice.answer }),
            React.createElement("input", { name: "answer", value: choice.answer, checked: currentAnswer
                    ? (0, isArray_1.default)(answer)
                        ? answer === null || answer === void 0 ? void 0 : answer.includes(choice.answer)
                        : answer === choice.answer
                    : undefined, onChange: formik.handleChange, onBlur: formik.handleBlur, disabled: isAnswered, type: hasMultipleCorrectAnswers ? 'checkbox' : 'radio' }),
            React.createElement("p", null, choice.label || alphabet[index]),
            isAnswered && hasCorrectAnswer && (React.createElement("span", null, isCorrectChoice(choice) ? 'correct' : 'incorrect')))));
});
exports.QuestionChoice = QuestionChoice;
var QuestionInput = React.forwardRef(function QuestionInput(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "as"]);
    var _c = React.useContext(QuestionContext), isAnswered = _c.isAnswered, formik = _c.formik;
    var errors = formik.errors, values = formik.values, initialValues = formik.initialValues;
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-input": (errors === null || errors === void 0 ? void 0 : errors.answer) ? 'error' : '' }),
        React.createElement("label", { htmlFor: "answer" }, "Your answer"),
        React.createElement("textarea", { rows: 6, name: "answer", id: "answer", value: initialValues.answer || values.answer || undefined, onChange: formik.handleChange, onBlur: formik.handleBlur, disabled: isAnswered, placeholder: "Type your answer..." }),
        (errors === null || errors === void 0 ? void 0 : errors.answer) && (React.createElement("div", { "data-sr-quiz-question-error": "" }, errors === null || errors === void 0 ? void 0 : errors.answer))));
});
exports.QuestionInput = QuestionInput;
var QuestionCodeSandbox = React.forwardRef(function QuestionCodeSandbox(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "as"]);
    var formik = React.useContext(QuestionContext).formik;
    React.useEffect(function () {
        formik.setValues({ answer: 'NA' });
    }, []);
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-input": "" }),
        React.createElement(sandpack_react_1.SandpackLayout, null,
            React.createElement(sandpack_react_1.SandpackCodeEditor, { style: { height: 400 } }))));
});
var QuestionCode = React.forwardRef(function QuestionCode(_a, forwardRef) {
    var _b;
    var children = _a.children, _c = _a.as, Comp = _c === void 0 ? 'div' : _c, props = __rest(_a, ["children", "as"]);
    var currentQuestion = React.useContext(QuestionContext).currentQuestion;
    var files = (_b = currentQuestion.code) === null || _b === void 0 ? void 0 : _b.reduce(function (a, v) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a["/".concat(v.filename)] = { code: v.code, active: v.active }, _a)));
    }, {});
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-input": "" }), currentQuestion.type === 'code' && currentQuestion.code ? (React.createElement(sandpack_react_1.SandpackProvider, { customSetup: {
            entry: "/".concat(currentQuestion.code[0].filename),
        }, theme: sandpack_themes_1.nightOwl, files: files },
        children,
        React.createElement(QuestionCodeSandbox, null))) : (children)));
});
exports.QuestionCode = QuestionCode;
var QuestionBody = React.forwardRef(function QuestionBody(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "as"]);
    return (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-body": "" }), children));
});
exports.QuestionBody = QuestionBody;
var QuestionAnswer = React.forwardRef(function QuestionAnswer(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "as"]);
    var _c = React.useContext(QuestionContext), isAnswered = _c.isAnswered, syntaxHighlighterTheme = _c.syntaxHighlighterTheme, currentQuestion = _c.currentQuestion, config = _c.config;
    var questionBodyRenderer = config.questionBodyRenderer;
    return isAnswered && currentQuestion.answer ? (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-answer": "" }),
        React.createElement(React.Fragment, null,
            questionBodyRenderer ? (questionBodyRenderer(currentQuestion.answer)) : (React.createElement(markdown_1.default, { syntaxHighlighterTheme: syntaxHighlighterTheme }, currentQuestion.answer)),
            children))) : null;
});
exports.QuestionAnswer = QuestionAnswer;
var QuestionSubmit = React.forwardRef(function QuestionSubmit(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "as"]);
    var _c = React.useContext(QuestionContext), isAnswered = _c.isAnswered, isSubmitting = _c.isSubmitting;
    return isAnswered ? null : (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-submit": "" }),
        React.createElement(button_1.default, { disabled: isAnswered, isLoading: isSubmitting, type: "submit" }, children)));
});
exports.QuestionSubmit = QuestionSubmit;
var QuestionFooter = React.forwardRef(function QuestionFooter(_a, forwardRef) {
    var children = _a.children, _b = _a.as, Comp = _b === void 0 ? 'footer' : _b, props = __rest(_a, ["children", "as"]);
    var _c = React.useContext(QuestionContext), isAnswered = _c.isAnswered, answeredNeutral = _c.answeredNeutral, isLast = _c.isLast, answeredCorrectly = _c.answeredCorrectly, syntaxHighlighterTheme = _c.syntaxHighlighterTheme, config = _c.config;
    var focusRef = React.useRef();
    React.useEffect(function () {
        isAnswered && focusRef.current.focus();
    }, [isAnswered]);
    var afterCompletionMessages = config.afterCompletionMessages;
    return isAnswered ? (React.createElement(Comp, __assign({}, props, { ref: forwardRef, "data-sr-quiz-question-footer": "" }),
        React.createElement("div", { ref: focusRef, tabIndex: -1 },
            React.createElement(markdown_1.default, { syntaxHighlighterTheme: syntaxHighlighterTheme }, answeredNeutral
                ? isLast
                    ? afterCompletionMessages.neutral.last
                    : afterCompletionMessages.neutral.default
                : answeredCorrectly
                    ? isLast
                        ? afterCompletionMessages.correct.last
                        : afterCompletionMessages.correct.default
                    : isLast
                        ? afterCompletionMessages.incorrect.last
                        : afterCompletionMessages.incorrect.default),
            children))) : null;
});
exports.QuestionFooter = QuestionFooter;
